/* eslint-disable max-len */
import 'react';

const SidebarImportSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="currentColor"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M3.111 5.383v-.939c0-.981.796-1.777 1.778-1.777h6.222c.982 0 1.778.796 1.778 1.777v7.112c0 .981-.796 1.777-1.778 1.777H4.89a1.778 1.778 0 01-1.778-1.777v-.754h0M9.362 7.778H2.251"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.403 5.333l2.514 2.514-2.514 2.515"
            />
        </g>
    </svg>
);
export default SidebarImportSvg;
